import { useParams } from 'react-router-dom';
import { useOperationHook } from './useOperationHook';

export const useWaybillResolver = (): string | undefined => {
    const { waybillNo: paramWaybillNo, waybillNumber: paramWaybillNumber } = useParams<{ waybillNo?: string; waybillNumber?: string }>();
    const { waybillNo: hookWaybill } = useOperationHook();
    return paramWaybillNo || paramWaybillNumber || hookWaybill;
};

export const useIsWaybillFromParam = (): boolean => {
    const { waybillNo, waybillNumber } = useParams<{ waybillNo?: string; waybillNumber?: string }>();
    return !!(waybillNo || waybillNumber);
};
